const VIDEO_ID = 'dsaas-digital-product';
const VIDEO_LOCATION = 'digital_product_video';

const muxPlaybackId =
  process.env['NEXT_PUBLIC_MUX_PLAYBACK_ID'] || 'YVXCYaWa9nYxNfWf4yR4E02I4hPpMQxeFFI501NeqhxLM';

export const VIDEO_URL = `https://stream.mux.com/${muxPlaybackId}/highest.mp4`;

/**
 * Converts video time from seconds to mm:ss format.
 *
 * Examples:
 * 0   -> 0:00
 * 65  -> 1:05
 * 345 -> 5:45
 * 585 -> 9:45
 */
const formatVideoTime = (seconds: number): string => {
  if (!Number.isFinite(seconds)) {
    return '0:00';
  }

  const totalSeconds = Math.round(seconds);

  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * Creates the common analytics payload used by
 * video play, pause and completed events.
 */
export const getVideoAnalyticsData = (video: HTMLVideoElement) => {
  const currentTimeSeconds = Number.isFinite(video.currentTime) ? Math.round(video.currentTime) : 0;

  const durationSeconds = Number.isFinite(video.duration) ? Math.round(video.duration) : 0;

  const progressPercent =
    durationSeconds > 0
      ? Math.min(100, Math.round((currentTimeSeconds / durationSeconds) * 100))
      : 0;

  return {
    page: window.location.pathname,
    location: VIDEO_LOCATION,
    videoId: VIDEO_ID,
    videoUrl: VIDEO_URL,
    currentTime: formatVideoTime(currentTimeSeconds),
    duration: formatVideoTime(durationSeconds),
    progressPercent,
  };
};
